import React, { useEffect, useState } from "react";
import DropzoneThumbnail from "../dropzone/DropzoneThumbnail";
import StoriesService from "../../services/StoriesService";
import { toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";

const RecordedAnswersAddModal = ({ type, characters = [], answer = {} }) => {
  const [audio, setAudio] = useState(null);
  const [stories, setStories] = useState([]);
  const [locations, setLocations] = useState([]);
  const [storyQuestions, setStoryQuestions] = useState([]);
  const [answerPosition, setAnswerPosition] = useState({});

  const getAllStories = async () => {
    try {
      const response = await StoriesService.getStories();
      if (response) {
        setStories(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllStoryQuestion = async () => {
    try {
      const response = null;
      if (response) {
        setStoryQuestions(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSelectStory = (selectedList, selectedItem) => {
    var ids = selectedList.map((item) => item);
    setLocations(ids);
  };

  const onRemoveStory = (selectedList, removedItem) => {
    var ids = selectedList.map((item) => item);
    setLocations(ids);
  };

  const selectedStory = stories.filter(
    (story) => story.id === answer?.story?._id
  );

  // const selectedQuestion = locations.filter(
  //   (question) => question._id == answer?.questions_list?._id
  // );
  // console.log("selectedQuestion", selectedQuestion);

  const handleOnChangeQuestion = (story, question) => {
    const clone = { ...answerPosition };
    clone[story.id] = {
      question: question,
      position: clone[story.id]?.position || -1,
    };
    setAnswerPosition(clone);
  };

  const handleOnChangePosition = (story, position) => {
    const clone = { ...answerPosition };
    clone[story.id] = {
      question: clone[story.id]?.question,
      position: position,
    };
    setAnswerPosition(clone);
  };

  const addRecordedAnswerForm = async (event) => {
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("audio", audio);
      formData.append("answerPosition", JSON.stringify(answerPosition));

      const response = null;
      if (response) {
        toast.success("Family member added");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const editRecordedAnswerForm = async (event) => {
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("audio", audio);
      // formData.append("answerPosition", JSON.stringify(answerPosition));
      formData.append("answer", answer?._id);

      const response = null;
      if (response) {
        toast.success("Family member update");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllStories();
    getAllStoryQuestion();
  }, []);

  return (
    <div>
      <form
        onSubmit={
          type == "add" ? addRecordedAnswerForm : editRecordedAnswerForm
        }
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {type == "add" ? "Add Recorded Answer" : "Edit Recorded Answer"}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label for="recipient-name" className="col-form-label">
                  Character
                </label>
                <select className="form-control" name="character">
                  {characters.map((character) => (
                    <option
                      selected={
                        character._id == answer?.character?._id ? true : false
                      }
                      value={character._id}
                    >
                      {character.nameOfFamilyMember}
                    </option>
                  ))}
                </select>
              </div>

              {type !== "edit" && (
                <div className="mb-3">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Select Stories
                  </label>
                  <Multiselect
                    options={stories} // Options to display in the dropdown
                    selectedValues={selectedStory} // Preselected value to persist in dropdown
                    onSelect={onSelectStory} // Function will trigger on select event
                    onRemove={onRemoveStory} // Function will trigger on remove event
                    displayValue="title" // Property name to display in the dropdown options
                  />
                </div>
              )}

              {locations.map((location, index) => {
                const story = storyQuestions.find(
                  (sq) => sq.story?._id == location._id
                );

                if (!story) return null;

                return (
                  <div key={index}>
                    <fieldset>
                      <legend style={{ fontSize: 18 }}>{location.title}</legend>
                      <div className="mb-1">
                        <label className="col-form-label">
                          Select Question
                        </label>
                        <select
                          // defaultValue={story.questions.filter((q) => q._id)}
                          onChange={(e) =>
                            handleOnChangeQuestion(location, e.target.value)
                          }
                          className="form-control"
                        >
                          <option value={""}>Select Question</option>
                          {story.questions.map((q) => (
                            <option value={q._id}>{q.title}</option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label className="col-form-label">Position</label>
                        <input
                          className="form-control"
                          onChange={(event) =>
                            handleOnChangePosition(location, event.target.value)
                          }
                          type="number"
                          placeholder="Answer Position"
                          defaultValue={answer?.position}
                        />
                      </div>
                    </fieldset>
                  </div>
                );
              })}

              <div className="mb-3">
                <label for="recipient-name" className="col-form-label">
                  Recording
                </label>
                <DropzoneThumbnail
                  accept={{
                    "audio/*": [],
                  }}
                  onFileUpload={setAudio}
                  title="audio"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                id="add-recorded-answer"
                type="submit"
                className="btn-model"
              >
                {type == "add"
                  ? "Add Recorded Answer "
                  : "Edit Recorded Answer"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RecordedAnswersAddModal;
